/**
 * URL filters of the unconfirmed asset groups list, as the router's
 * URLSearchParams serializer hands them over: every value a string. The page
 * itself reads and writes them through nuqs; this shape only lets other routes
 * link back to the list with its filters intact.
 */
type UnconfirmedListSearch = {
  orgs?: string;
  q?: string;
  page?: string;
  sort?: string;
};

const LIST_KEYS = ['orgs', 'q', 'page', 'sort'] as const;

export function pickUnconfirmedListSearch(search: Record<string, unknown>): UnconfirmedListSearch {
  const out: UnconfirmedListSearch = {};
  for (const key of LIST_KEYS) {
    const value = search[key];
    if (typeof value === 'string' && value.length > 0) out[key] = value;
  }
  return out;
}

/**
 * Pack the list filters into one string for the edit page's `list` param, so
 * opening a group and coming back lands on the same filtered list. Undefined
 * when there is nothing to keep.
 */
export function encodeUnconfirmedListSearch(search: UnconfirmedListSearch): string | undefined {
  const encoded = new URLSearchParams(pickUnconfirmedListSearch(search)).toString();
  return encoded.length > 0 ? encoded : undefined;
}

/** Unpack a `list` param; anything that is not a list filter is ignored. */
export function decodeUnconfirmedListSearch(raw: unknown): UnconfirmedListSearch {
  if (typeof raw !== 'string') return {};
  return pickUnconfirmedListSearch(Object.fromEntries(new URLSearchParams(raw)));
}
